import {
  sendRecoveryEmail as publicSendRecoveryEmail,
  sendActivationEmail as publicSendActivationEmail,
  recover as publicRecover,
} from './iam-recovery-v1-recovery-recovery.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const sendRecoveryEmail: MaybeContext<
  BuildRESTFunction<typeof publicSendRecoveryEmail> &
    typeof publicSendRecoveryEmail
> = /*#__PURE__*/ createRESTModule(publicSendRecoveryEmail);
export const sendActivationEmail: MaybeContext<
  BuildRESTFunction<typeof publicSendActivationEmail> &
    typeof publicSendActivationEmail
> = /*#__PURE__*/ createRESTModule(publicSendActivationEmail);
export const recover: MaybeContext<
  BuildRESTFunction<typeof publicRecover> & typeof publicRecover
> = /*#__PURE__*/ createRESTModule(publicRecover);

export {
  TenantType,
  StateType,
  PrivacyStatus,
  EmailTag,
  PhoneTag,
  AddressTag,
  StatusName,
  Reason,
  FactorType,
  Status,
  FactorStatus,
  MfaReason,
} from './iam-recovery-v1-recovery-recovery.universal.js';
export {
  RecoveryToken,
  SendRecoveryEmailRequest,
  Redirect,
  SendRecoveryEmailResponse,
  SendActivationEmailRequest,
  EmailOptions,
  SendActivationEmailResponse,
  RecoverRequest,
  StateMachineResponse,
  StateMachineResponseStateDataOneOf,
  Identity,
  Connection,
  ConnectionTypeOneOf,
  IdpConnection,
  AuthenticatorConnection,
  IdentityProfile,
  CustomField,
  V1CustomValue,
  V1CustomValueValueOneOf,
  V1ListValue,
  V1MapValue,
  SecondaryEmail,
  Phone,
  AddressWrapper,
  Address,
  Metadata,
  Email,
  StatusV2,
  Factor,
  CustomValue,
  CustomValueValueOneOf,
  ListValue,
  MapValue,
  RequireMfaData,
  V1Factor,
  MfaChallengeData,
  VerificationChallenge,
  VerificationChallengeFactorChallengeDataOneOf,
  PushChallengeData,
  WebAuthnChallengeData,
  CreateRecoveryTokenRequest,
  CreateRecoveryTokenResponse,
  SendRecoveryEmailOptions,
  SendActivationEmailOptions,
  RecoverOptions,
} from './iam-recovery-v1-recovery-recovery.universal.js';
export {
  TenantTypeWithLiterals,
  StateTypeWithLiterals,
  PrivacyStatusWithLiterals,
  EmailTagWithLiterals,
  PhoneTagWithLiterals,
  AddressTagWithLiterals,
  StatusNameWithLiterals,
  ReasonWithLiterals,
  FactorTypeWithLiterals,
  StatusWithLiterals,
  FactorStatusWithLiterals,
  MfaReasonWithLiterals,
} from './iam-recovery-v1-recovery-recovery.universal.js';
